import { render } from "./modalEdit.vue?vue&type=template&id=6b7a5a2d&scoped=true"
const script = {}

import "./modalEdit.vue?vue&type=style&index=0&id=6b7a5a2d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b7a5a2d"]])

export default __exports__